var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17015 4.87536C2.17015 4.27598 2.6505 3.79563 3.24987 3.79563H7.67799C7.81683 3.79563 7.95601 3.85264 8.05753 3.95415L10.1294 6.02603C10.4341 6.33076 10.8502 6.50397 11.2801 6.50397H22.7499C23.3492 6.50397 23.8296 6.98432 23.8296 7.58369V16.1687H24.9201V7.58369C24.9201 6.38202 23.9515 5.41341 22.7499 5.41341H11.2801C11.1412 5.41341 11.0021 5.35641 10.9005 5.25489L8.82867 3.18302C8.52393 2.87828 8.1079 2.70508 7.67799 2.70508H3.24987C2.0482 2.70508 1.07959 3.67369 1.07959 4.87536V21.667C1.07959 22.8687 2.0482 23.8373 3.24987 23.8373H17V22.7467H3.24987C2.6505 22.7467 2.17015 22.2664 2.17015 21.667V4.87536Z",
    fill: "#002852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 21.1689H17V20.1689H26V21.1689Z",
    fill: "#002852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 25.1689V16.1689H22V25.1689H21Z",
    fill: "#002852"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPlus);
export default __webpack_public_path__ + "static/media/folder_plus.0410b500.svg";
export { ForwardRef as ReactComponent };